const localeMessage = {
  'locale.english.type': 'en',
  'locale.english.name': '英語',
  'locale.japanese.type': 'ja',
  'locale.japanese.name': '日本語',
};

export default localeMessage;
